<template>
    <div>
      <h2>Impressum</h2>
      <div>
        Verantwortlich für den Inhalt sind
        Anika & Thorsten Jonas<br />
        spam [at] pix-share.com
      </div>

      <h2>Datenschutz</h2>
      <div>
        Die Webseite speichert keinerlei persönliche Daten.
        Zur ständigen Verbesserung des Services wird Google Analytics im anonymisierten Modus eingesetzt.
        Wenn dir das nicht gefällt, kannst du das Tracking hier komplett ausschalten: <a href="https://support.google.com/analytics/answer/181881">Google Analytics deaktivieren</a>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Impressum',
  created: function () {
  },
  data: function () {
    return {
    }
  }
}
</script>

<style>
div{
  margin-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/Impressum.vue